import {
  sendCustomAction,
  setGlobalContextProperty,
} from "datadog-loader/loader";

import { API_ROOT, TARGET } from "drop-in-ui/utils/configs";
import { VERSION } from "drop-in-ui/utils/version/version";

import { getFeClient } from "frontend-client";

const client = getFeClient(
  API_ROOT,
  TARGET,
  VERSION,
  sendCustomAction,
  setGlobalContextProperty
);

export { client };
